export const uselanguage = () => {
    const urlParams = new URL(window.location.href);
    const currentLanguage = urlParams.pathname.split('/')[1];

    return currentLanguage;
};